import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { ShieldCheck, ShieldX, Loader2 } from "lucide-react";

export default function ConfirmLogin() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ status: token ? "busy" : "error", msg: token ? "" : "Invalid confirmation link." });
  useEffect(() => {
    if (!token) return;
    api.post("/auth/confirm-login", { token })
      .then((r) => setState({ status: "ok", msg: `Sign-ins from ${r.data.country} are now trusted on your account.` }))
      .catch((ex) => setState({ status: "error", msg: formatApiErrorDetail(ex?.response?.data?.detail) || ex.message }));
  }, [token]);
  return (
    <main className="min-h-[calc(100vh-5rem)] flex items-center justify-center px-4" data-testid="confirm-login-page">
      <div className="w-full max-w-md glass rounded-3xl p-8 rise text-center">
        {state.status === "busy" && <Loader2 className="w-8 h-8 mx-auto animate-spin text-cyan-400" />}
        {state.status === "ok" && <ShieldCheck className="w-10 h-10 mx-auto text-emerald-400" />}
        {state.status === "error" && <ShieldX className="w-10 h-10 mx-auto text-red-400" />}
        <h1 className="font-display text-2xl font-bold mt-4">{state.status === "ok" ? "Sign-in confirmed" : state.status === "error" ? "Couldn't confirm" : "Confirming…"}</h1>
        <p className="text-sm text-slate-400 mt-2" data-testid="confirm-login-message">{state.msg}</p>
        {state.status !== "busy" && <Link to="/login" className="inline-flex items-center justify-center mt-6 h-11 px-6 rounded-full bg-white text-slate-950 font-semibold hover:bg-slate-100" data-testid="confirm-login-signin">Sign in now</Link>}
      </div>
    </main>
  );
}
